import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { CollectionsBento } from "@/components/CollectionsBento";
import { BestSellers } from "@/components/BestSellers";
import { ShadeLab } from "@/components/ShadeLab";
import { NewLaunches } from "@/components/NewLaunches";
import { BlenderShowcase } from "@/components/BlenderShowcase";
import { BrushAtelier } from "@/components/BrushAtelier";
import { Reels } from "@/components/Reels";
import { Reviews } from "@/components/Reviews";
import { Proof } from "@/components/Proof";
import { InstagramGrid } from "@/components/InstagramGrid";
import { Newsletter } from "@/components/Newsletter";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";
import { Concierge } from "@/components/Concierge";
import { LiveProvider } from "@/lib/live";
import { initPixel } from "@/lib/pixel";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id = requestAnimationFrame(function raf(t) {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    });
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);
};

function App() {
  useEffect(() => initPixel(), []);
  useLenis();
  return (
    <LiveProvider>
    <div className="App relative overflow-x-clip bg-ink text-cream" data-testid="beauty-edit-landing">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <CollectionsBento />
        <BestSellers />
        <ShadeLab />
        <NewLaunches />
        <BlenderShowcase />
        <BrushAtelier />
        <Reels />
        <Reviews />
        <Proof />
        <InstagramGrid />
        <Newsletter />
      </main>
      <Footer />
      <StickyBar />
      <Concierge />
      <Toaster theme="dark" position="bottom-center" />
    </div>
    </LiveProvider>
  );
}

export default App;
